import type { RoadmapRow } from '../../productgovernance/framework';

type Props = { items?: RoadmapRow[] };

export function RoadmapGovernancePanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.roadmap} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{item.roadmap}</p>
            <span className="shrink-0 rounded-full bg-brand-50 px-2 py-0.5 text-xs font-medium text-brand-700 dark:bg-brand-950 dark:text-brand-300">
              {item.status}
            </span>
          </div>
          <div className="mt-2 h-1.5 rounded-full bg-slate-100 dark:bg-slate-800">
            <div className="h-1.5 rounded-full bg-brand-500" style={{ width: `${item.progress}%` }} />
          </div>
          <p className="mt-1 text-xs text-slate-500">{item.progress}% complete</p>
        </div>
      ))}
    </div>
  );
}
